import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Navbar from './components/Navbar';
import AppLayout from './components/AppLayout';
import Home from './pages/globalComponents/home';
import Login from './pages/globalComponents/login';
import Signup from './pages/globalComponents/sign';
// import availabilitySettings from './pages/availabilitySettings';
import Dashboard from './pages/Learner/dashboard';
import MentorAvailability from './pages/mentorAvailability';
import ConnectionReq from './pages/connectionReq';
import Schedulemeeting from './pages/schedulemeeting';
import MyRequests from './pages/myRequests';
import MentorProfile from './pages/mentorProfile';
import AboutUs from './pages/globalComponents/AboutUs';
import AccountSettings from "./pages/accountsettings";
import Certificate from "./pages/certificate";
import ChangePassword from "./pages/changepassword";
import ChatDetails from "./pages/chatDetails";
import Chat from "./pages/chats";
import CommunityPost from "./pages/globalComponents/communityPost";
import ContactUs from "./pages/contactUs";
import Conversation from "./pages/conversations";
import CreateCertificate from "./pages/createCertificate";
import CreateNewGroup from "./pages/createNewGroup";
import CurrentProjects from "./pages/Learner/currentProjects";
import Curriculum from "./pages/Learner/Curriculum";
import DiscoverLearner from "./pages/mentor/DiscoverLearners";
import DiscussionForum from "./pages/globalComponents/discussionForum";
import Error from "./pages/globalComponents/error404";
import FAQs from "./pages/FAQs";
import Feedback from "./pages/feedback";
import GoalDetail from "./pages/Learner/goalDetail";
import HelpSupport from "./pages/helpSupport";
import LanguageSettings from "./pages/languageSettings";
import ManageAccountSettings from "./pages/manageAccountSettings";
import MeetingScheduled from "./pages/meetingScheduled";
import Mentorexp from "./pages/mentor-exp";
import Mentor from "./pages/mentor";
import MentorHome from "./pages/mentorHome";
import MentorNotification from "./pages/mentorNotifications";
import MyGoal from "./pages/Learner/myGoal";
import Notification from "./pages/notification";
import MentorsideRequests from './pages/mentor/mentorsideRequests';
import NotificationSettings from "./pages/notificationSettings";
import Policy from "./pages/policySettings";
import ProfileManagement from "./pages/profileManagement";
import ProfileManagementMentor from './pages/profileManagementMentor';
import Termsofservice from "./pages/globalComponents/termsOfservice";
import UpcomingGroup from "./pages/upcomingSessions";
import UpcomingSessions from './pages/upcomingSessions';
import ComingSoon from './pages/globalComponents/comingsoon';
import LearnerRequests from './pages/Learner/learner-requests';
import CreateProjects from './pages/Learner/createProjects';
import ProjectDetails from './pages/Learner/projectDetails';
import PostDetails from './pages/globalComponents/postDetails';
import Bookmarks from './pages/globalComponents/bookmark';
import AvailabilitySettings from './pages/mentor/availabilitySettings';
import CertificatePage from './pages/Learner/certificateGenerator';
import CreateSessions from './pages/mentor/createSessions';
import Sessions from './pages/globalComponents/Sessions';
import ResetPassword from "./pages/globalComponents/ResetPassword";
import VerifyEmail from './pages/globalComponents/verifyEmail';



import SideNavbar from './pages/globalComponents/SideNavbar';

// Mentor screens
import Learnerlist from './pages/mentor/Learner-list';
import MentorDashboard from './pages/mentor/mentor-dash';
import CreateLessons from './pages/mentor/createLessons';
// import MentorRequests from './pages/mentor/mentor-requests';


//  ai screens
import BookMark from "./pages/AI/bookmarkResources";
import ChatHistory from "./pages/AI/chatHistory";
import CcourseLearning from "./pages/AI/courseLearning"
import CourseLearningContent from './pages/AI/courseLearningContent';
import DetailedProgress from "./pages/AI/detailedProgress";
import DownloadResource from "./pages/AI/DownloadResources";
import GiaAgent from "./pages/AI/giaagent";
import GiaCharts from "./pages/AI/giacharts";
import GiaMentor from "./pages/AI/giaMentor";
import LearningContent from "./pages/AI/LearnContentDetails";
import LearningContentQuiz from "./pages/AI/LearningContentQuiz";
import LessonContentVideos from "./pages/AI/LessonContentVideo";
import ProgressTracking from "./pages/AI/progressTracking";
// import ResourceDetails from "./pages/AI/ResourceDetails";
import Resource from "./pages/globalComponents/Resources";
// import AvailabilitySettings from './pages/availabilitySettings';
import LessonDetails from './pages/Learner/lessonDetails';
// import ResourceDetails from './pages/AI/ResourceDetails';
import ResourceDetails from './pages/globalComponents/resourceDetails';
import ForgotPassword from './pages/globalComponents/ForgotPassword';
import AcceptInvite from './pages/globalComponents/acceptInvite';
import InviteMentor from './pages/globalComponents/mentorInvite';
import EventDetail from './pages/globalComponents/EventDetail';
import EventsList from './pages/globalComponents/EventList';
import EventForm from "./pages/globalComponents/EventForm";
import MyEvents from "./pages/globalComponents/MyEvents";





function App() {
  return (
    <Router>
      {/* <Navbar /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/termsOfservice" element={<Termsofservice />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/accept-invite/:token" element={<AcceptInvite />} />
        <Route path="/admin/invite-mentor" element={<InviteMentor />} />



        {/* protected screens */}
        <Route element={<AppLayout />}>
          {/* mentor screens */}
          <Route path="/mentor-dash" element={<MentorDashboard />} />
          <Route path='/coming' element={<ComingSoon />} />
          {/* <Route path='/availabilitySettings' element={<AvailabilitySettings />} /> */}
          <Route path='/learner-list' element={<Learnerlist />} />
          <Route path="/learner-dash" element={<Dashboard />} />
          <Route path="/accountSettings" element={<AccountSettings />} />
          <Route path="/mentorexp" element={<Mentorexp />} />
          <Route path="/mentor" element={<Mentor />} />
          <Route path='/mentorAvail' element={<MentorAvailability />} />
          <Route path="/connectionReq/:id" element={<ConnectionReq />} />
          <Route path="/schedulemeeting" element={<Schedulemeeting />} />
          <Route path="/meetingscheduled" element={<MeetingScheduled />} />
          <Route path="/myrequests/:id" element={<MyRequests />} />
          <Route path="/mentorProfile" element={<MentorProfile />} />
          <Route path="/availability" element={<AvailabilitySettings/>} />
          {/* <Route path="/learnerProfile" element={<LearnerProfile />} /> */}
          <Route path="/createLessons" element={<CreateLessons />} />
          <Route path="/createSessions" element={<CreateSessions />} />
          <Route path="/sessions" element={<Sessions />} />
          <Route path="/events" element={<EventsList />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/events/:id/edit"    element={<EventForm />} />
          <Route path="/my-events"          element={<MyEvents />} />
          <Route path="/events/new"         element={<EventForm />} />

          {/* leaner-screens */}
          <Route path="/lesson/:id" element={<LessonDetails />} />
          <Route path="/createProjects" element={<CreateProjects />} />
          <Route path="/certificate" element={<Certificate />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/chatdetails" element={<ChatDetails />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/communityPost" element={<CommunityPost />} />
          <Route path="/contactUs" element={<ContactUs />} />
          <Route path="/conversation" element={<Conversation />} />
          <Route path="/createCertificate" element={<CreateCertificate />} />
          <Route path="/createNewGroup" element={<CreateNewGroup />} />
          <Route path="/currentProjects" element={<CurrentProjects />} />
          <Route path="/projects/:id" element={<ProjectDetails />} />
          <Route path="/curriculum" element={<Curriculum />} />
          <Route path="/discoverLearner" element={<DiscoverLearner />} />
          <Route path="/discussionForum" element={<DiscussionForum />} />
          <Route path="/error404" element={<Error />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/helpSupport" element={<HelpSupport />} />
          <Route path="/languageSettings" element={<LanguageSettings />} />
          <Route path="/manageaccountSettings" element={<ManageAccountSettings />} />
          <Route path="/meetingScheduled" element={<MeetingScheduled />} />
          <Route path="/mentorexp" element={<Mentorexp />} />
          <Route path="/Mentor" element={<Mentor />} />
          <Route path="/mentoravailability" element={<MentorAvailability />} />
          <Route path="/mentorhome" element={<MentorHome />} />
          <Route path="/mentornotification" element={<MentorNotification />} />
          <Route path="/mentorsiderequest" element={<MentorsideRequests />} />
          <Route path="/mygoal" element={<MyGoal />} />
          <Route path="/goal/:goalId" element={<GoalDetail />} />
          <Route path="/myrequest" element={<MyRequests />} />
          <Route path="/Notification" element={<Notification />} />
          <Route path="/NotificationSettings" element={<NotificationSettings />} />
          <Route path="/profileManagement" element={<ProfileManagement />} />
          <Route path="/profileManagementMentor" element={<ProfileManagementMentor />} />
          <Route path="/upcomingGroupSession" element={<UpcomingGroup />} />
          <Route path="/upcomingSession" element={<UpcomingSessions />} />
          <Route path='/learner-requests' element={<LearnerRequests />} />
          <Route path="/posts/:id" element={<PostDetails />} />
          <Route path="/resources/:id" element={<ResourceDetails />} />
          <Route path="/certificate/:lessonId" element={<CertificatePage />} />



          {/*ai screens */}
          <Route path="/bookmarkResources" element={<BookMark />} />
          <Route path="/chatHistory" element={<ChatHistory />} />
          <Route path="/courseLearning" element={<CcourseLearning />} />
          <Route path="/courseLearningContent" element={<CourseLearningContent />} />
          <Route path="/detailedProgress" element={<DetailedProgress />} />
          <Route path="/downloadResources" element={<DownloadResource />} />
          <Route path="/giaAgent" element={<GiaAgent />} />
          <Route path="/giaCharts" element={<GiaCharts />} />
          <Route path="/giaMentor" element={<GiaMentor />} />
          <Route path="/learnContentDetails" element={<LearningContent />} />
          <Route path="/learningContentQuiz" element={<LearningContentQuiz />} />
          <Route path="/lessonContentVideo" element={<LessonContentVideos />} />
          <Route path="/progressTracking" element={<ProgressTracking />} />
          <Route path="/resourceDetails" element={<ResourceDetails />} />
          <Route path="/resources" element={<Resource />} />


          {/* general screens*/}
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/termsOfservice" element={<Termsofservice />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/bookmark" element={<Bookmarks />} />









        </Route>

      </Routes>
    </Router>
  );
}

export default App;
